import * as React from "react";
import "../Styles/style.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "../../api/ipconfig";
import MyadsNavigation from "./myads-navigation";
import UserDetails from "./userDetails";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import InnerLoader from "../loader/innerLoader";
import { AuthContext } from "../../context/AuthContext";
import { Pagination } from "@mui/material";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function InspectionPackageHistory() {
  const { user } = React.useContext(AuthContext);

  const [imagePath, setImagePath] = useState("");
  const [packageHistory, setPackageHistory] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [statusMsg, setStatusMsg] = useState("");
  const [isLoading, setLoading] = useState(true);
  const [page, setPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(0);

  const handleChange = (event, value) => {
    setPage(value);
  };

  const handleBarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    const fetchPaymentHistory = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${baseUrl}/userinspectionpackagehistory`,
          {
            params: {
              user_id: user?.id,
              page,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setPackageHistory(response?.data?.history?.data);
        setImagePath(response?.data?.imagepath);
        setTotalPages(response?.data?.history?.last_page);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching payment history", error);
      }
    };
    if (user) {
      fetchPaymentHistory();
    }
  }, [page, user]);

  const requestForRefund = async (orderId) => {
    try {
      const token = localStorage.getItem("token");
      const formData = new FormData();

      formData.append("orderId", orderId);
      await axios.post(`${baseUrl}/fame/RequestRefund `, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setStatusMsg("Successfully requested for refund");
      setOpen(true);
      const response = await axios.get(`${baseUrl}/fame/getPaymentsByUserId`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          user_id: user.id,
        },
      });
      const updatedPaymentHistory = response.data;
      setPackageHistory(updatedPaymentHistory);
    } catch (error) {
      console.error("Error requested for refund:", error);
    }
  };

  return (
    <>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleBarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleBarClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          {statusMsg}
        </Alert>
      </Snackbar>
      <div className="MyAds_main">
        <UserDetails />
        <div className="container-md MyAds_body">
          <div className="row pb-5">
            <div className="col-lg-2 p-0">
              <MyadsNavigation />
            </div>
            <div className="col-lg-10 ">
              {isLoading ? (
                <InnerLoader />
              ) : packageHistory?.length ? (
                <>
                  <div className=" bgSecondary boxShadow mb-3 d-992-none">
                    <div className="row paymentHistory_header">
                      <div className="col-lg-2 col-2">
                        <h6 className="text-center">Package</h6>
                      </div>
                      <div className="col-lg-1 col-2">
                        <h6>Used</h6>
                      </div>
                      <div className="col-lg-1 col-2">
                        <h6>Remaining</h6>
                      </div>
                      <div className="col-lg-2 col-2">
                        <h6>Amount</h6>
                      </div>
                      <div className="col-lg-2 col-3">
                        <h6>Puchased</h6>
                      </div>
                      <div className="col-lg-2 col-3">
                        <h6>Expiry</h6>
                      </div>
                    </div>
                  </div>
                  {packageHistory?.map((item) => (
                    <div className=" bg-white paymentHistory_list boxShadow mb-3">
                      <div className="row align-items-center py-2">
                        <div className="col-lg-2 col-md-3 col-4">
                          <div className="d-flex">
                            <img
                              src={`${imagePath}/${item?.package_image}`}
                              className="packageIcon"
                              alt={item?.package_title}
                              srcSet=""
                            />

                            <h6 className="my-auto">{item?.package_title}</h6>
                          </div>
                        </div>
                        <div className="col-lg-1 col-md-3 col-4">
                          <h6>
                            {item?.package_quantity - item?.remaining_quantity}
                          </h6>
                        </div>
                        <div className="col-lg-1 col-md-2 col-4 text-capitalize">
                          <h6>{item?.remaining_quantity}</h6>
                        </div>
                        <div className="col-lg-2 col-md-2 col-4">
                          <h6>
                            <sub>PKR</sub> {item?.package_price}
                          </h6>
                        </div>
                        <div className="col-lg-2 col-md-4 col-12 text-start mb-2 mb-md-0">
                          <h6>{item?.buy_date}</h6>
                        </div>
                        <div className="col-lg-2 col-md-4 col-12 text-start mb-2 mb-md-0">
                          <h6>{item?.expiry_date}</h6>
                        </div>
                      </div>
                    </div>
                  ))}
                  <Pagination
                    count={totalPages}
                    page={page}
                    onChange={handleChange}
                    color="secondary"
                  />
                </>
              ) : (
                <div className="adsSection">
                  <div className="No_ads text-center">
                    <p>no history available</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
